export default __webpack_public_path__ + "static/icons-hd-availability-bbad04fdc2f397401f04ef25e3b9e8bf.svg";